/* SNUG Global — homepage motion (Lane A). Vanilla, tiny, fail-safe. */
(function () {
  'use strict';
  var doc = document, html = doc.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- scroll reveal (once) --- */
  html.classList.add('sg-js');
  function revealAll() {
    var els = doc.querySelectorAll('.sg-reveal');
    for (var i = 0; i < els.length; i++) els[i].classList.add('sg-in');
  }
  function initReveal() {
    if (reduced || !('IntersectionObserver' in window)) { revealAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('sg-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    doc.querySelectorAll('.sg-reveal').forEach(function (el) { io.observe(el); });
    setTimeout(revealAll, 3000); /* fail-safe: never leave content hidden */
  }

  /* --- hero rotator: crossfade every 5s, defer slides 2..n --- */
  function initHero() {
    var hero = doc.querySelector('[data-sg-hero]');
    if (!hero) return;
    var slides = hero.querySelectorAll('.sg-hero__slide');
    if (slides.length < 2) return;

    /* lazy-activate deferred slide images */
    function hydrate(slide) {
      slide.querySelectorAll('img[data-srcset], source[data-srcset], img[data-src], source[data-src]').forEach(function (el) {
        if (el.dataset.srcset) { el.srcset = el.dataset.srcset; el.removeAttribute('data-srcset'); }
        if (el.dataset.src) { el.src = el.dataset.src; el.removeAttribute('data-src'); }
      });
    }
    var idx = 0, started = false;
    function next() {
      var prev = idx;
      idx = (idx + 1) % slides.length;
      hydrate(slides[idx]); /* just-in-time: ensure live the moment it shows */
      slides[prev].classList.remove('is-active');
      slides[idx].classList.add('is-active');
      hydrate(slides[(idx + 1) % slides.length]); /* warm the following one, 5s ahead */
    }
    function start() {
      if (started) return;
      started = true;
      /* warm slide 2 ~1s before its first reveal — never in the LCP window */
      setTimeout(function () { hydrate(slides[1]); }, 4000);
      setInterval(next, 5000);
    }
    /* reduced motion: no rotation, so slides 2..n are never shown — skip fetching them */
    if (reduced) return;
    /* first interaction also warms slide 2 (covers pre-rotation engagement) */
    var warmOnce = function () { hydrate(slides[1]); };
    window.addEventListener('pointerdown', warmOnce, { once: true, passive: true });
    if (doc.readyState === 'complete') start();
    else window.addEventListener('load', start);
  }

  /* --- bgfill hydrator (2026-08-06): .sgc-card__bgfill imgs are authored with
     data-src/data-srcset only and had NO loader anywhere, so the blur-cover fill
     behind card photos never loaded. Lazy-load them near viewport. Deliberately
     does NOT touch .sgc-card__img--hover (sgc-commerce.js swaps that on
     mouseenter by design). Fail-safe: no IntersectionObserver = load all. --- */
  function hydrateBgfill(img) {
    if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
    if (img.dataset.sizes) { img.sizes = img.dataset.sizes; img.removeAttribute('data-sizes'); }
    if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
  }
  function initBgfill() {
    var imgs = doc.querySelectorAll('img.sgc-card__bgfill[data-src], img.sgc-card__bgfill[data-srcset]');
    if (!imgs.length) return;
    if (!('IntersectionObserver' in window)) {
      imgs.forEach(hydrateBgfill); return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { hydrateBgfill(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '300px 0px 300px 0px' });
    imgs.forEach(function (img) { io.observe(img); });
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', function () { initReveal(); initHero(); initBgfill(); });
  } else { initReveal(); initHero(); initBgfill(); }
})();


/* sgVidsFix v2 */
document.addEventListener('click',function(e){
  var card=e.target.closest('[data-sg-video]');
  if(!card) return;
  var v=card.querySelector('video'); var btn=card.querySelector('[data-sg-video-play]');
  if(!v) return;
  e.preventDefault();
  if(v.hidden){ v.hidden=false; if(btn) btn.style.display='none'; }
  if(!v.src && v.dataset.src){ v.src=v.dataset.src; v.muted=true; v.load();
    v.addEventListener('canplay',function(){ v.play().catch(function(){}); },{once:true}); return; }
  if(v.paused){ v.play().catch(function(){}); } else { v.pause(); }
},true);

/* sgPolicyClean v2: native /policies/* pages don't load sgp-pages.css, so legal
   bodies render as cramped, unstyled text. This: (1) strips raw CSS text leaked
   into the body, (2) removes consecutive duplicate words/lines, (3) injects
   scoped styling for headings/tables/lists/notes so policy pages match the theme.
   Conservative — never removes content nodes, only blanks pure-CSS dumps and
   collapses true adjacent repeats. */
(function(){
  var b=document.querySelector('.shopify-policy__body');if(!b)return;

  /* (1) strip raw CSS-rule text leaked into the prose */
  var w=document.createTreeWalker(b,NodeFilter.SHOW_TEXT);var kill=[];var n;
  while(n=w.nextNode()){var t=n.nodeValue;if(t&&t.indexOf('{')>-1&&/[.#][a-z-]+\s*\{[^}]*\}/i.test(t)&&t.length>120){kill.push(n);}}
  kill.forEach(function(n){n.nodeValue='';});

  /* (2) de-duplicate consecutive repeated words within a text node
     (e.g. "shipping shipping" -> "shipping"). Only collapses true adjacent
     repeats of the same 3+ char word; leaves everything else untouched. */
  var w2=document.createTreeWalker(b,NodeFilter.SHOW_TEXT);var n2;
  while(n2=w2.nextNode()){
    var v=n2.nodeValue;
    if(v&&/\b(\w{3,})\s+\1\b/i.test(v)){
      var fixed=v.replace(/\b(\w{3,})(\s+)\1\b/gi,'$1');
      if(fixed!==v)n2.nodeValue=fixed;
    }
  }
  /* collapse two identical consecutive block siblings (duplicated <p>/<li>) */
  var prev=null;
  Array.prototype.slice.call(b.querySelectorAll('p,li,h2,h3')).forEach(function(el){
    var txt=(el.textContent||'').trim();
    if(prev&&txt&&txt===prev.txt&&el.parentNode){el.parentNode.removeChild(el);}
    else prev={txt:txt};
  });

  /* (3) inject scoped styling (mirrors sgp-pages.css .sgp-prose treatment) */
  if(!document.getElementById('sg-policy-css')){
    var css=document.createElement('style');css.id='sg-policy-css';
    css.textContent=
    '.shopify-policy__container{max-width:860px!important;padding:3rem 1.25rem 5rem!important;margin:0 auto!important;}'+
    '.shopify-policy__title h1{font-family:"Fraunces",Georgia,serif!important;font-size:clamp(2.1rem,5vw,3rem)!important;font-weight:600!important;margin:0 0 1.75rem!important;letter-spacing:-.01em;}'+
    '.shopify-policy__body{max-width:68ch!important;width:auto!important;line-height:1.7;color:#2a2622;}'+
    '.shopify-policy__body h2{font-family:"Fraunces",Georgia,serif!important;font-size:1.65rem!important;font-weight:600!important;margin:2.6rem 0 1rem!important;}'+
    '.shopify-policy__body h3{font-family:"Fraunces",Georgia,serif!important;font-size:1.25rem!important;font-weight:600!important;margin:1.9rem 0 .7rem!important;}'+
    '.shopify-policy__body p{margin:0 0 1.05rem!important;}'+
    '.shopify-policy__body a{color:#b4674a!important;text-underline-offset:3px;}'+
    '.shopify-policy__body a:hover{color:#2a2622!important;}'+
    '.shopify-policy__body ul,.shopify-policy__body ol{margin:0 0 1.2rem!important;padding-left:1.3rem!important;}'+
    '.shopify-policy__body li{margin-bottom:.4rem!important;}'+
    '.shopify-policy__body li::marker{color:#b4674a;}'+
    '.shopify-policy__body table{width:100%!important;border-collapse:collapse!important;margin:1.4rem 0 2rem!important;background:transparent!important;font-size:.95rem;}'+
    '.shopify-policy__body table th,.shopify-policy__body table td{border:1px solid rgba(42,38,34,.16)!important;padding:.8rem 1rem!important;text-align:left!important;vertical-align:top!important;}'+
    '.shopify-policy__body table th{font-weight:500!important;background:rgba(180,103,74,.07)!important;letter-spacing:.02em;white-space:nowrap;}'+
    '@media(max-width:560px){.shopify-policy__body table th{white-space:normal;}}'+
    '.shopify-policy__body .note,.shopify-policy__body .highlight-box{background:rgba(180,103,74,.07)!important;border-left:3px solid #b4674a!important;padding:1.05rem 1.25rem!important;margin:1.3rem 0!important;border-radius:0!important;box-shadow:none!important;}'+
    '.shopify-policy__body strong{font-weight:600;}';
    document.head.appendChild(css);
  }
})();
